/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForScriptExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForScriptExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForScriptExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForScriptExecution>): BackgroundJobPayloadForScriptExecution {
        let obj = Object.assign(new BackgroundJobPayloadForScriptExecution(), model);
        BackgroundJobPayloadForScriptExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForScriptExecution>): BackgroundJobPayloadForScriptExecution {
        if (!model) return null;
        return BackgroundJobPayloadForScriptExecution.newInstance(<BackgroundJobPayloadForScriptExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForScriptExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForScriptExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForScriptExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForScriptExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    job_id: string;

    version: string;

    /**
     * Script Configuration Type
     */
    handler_type: models.ScriptExecutionConfigType;

    /**
     * parameters to script
     */
    execution_params: any;

}
